export default __webpack_public_path__ + "static/media/ANNUAIRE.08d31eb3.png";